export const DEV = false;

export const BASENAME = DEV ? "/" : "/DocumentacionLiquidacionesWeb/#/";

const APIURLDEV = "http://gal-tomcat-mobile-test:8080/mobile-rest-services/";
const APIURLPROD = "https://www.e-galenomovil.com.ar/liquidaciones-services/";
export const APIURL = DEV ? APIURLDEV : APIURLPROD;

export const ACCEPT =
  "image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.oasis.opendocument.spreadsheet, application/x-7z-compressed, application/x-rar-compressed, application/*, application/x-zip-compressed, multipart/x-zip, text/csv, application/x-rar-compressed, application/rar, application/octet-stream, text/plain";
